import { Switch, Field, Label } from '@headlessui/react';
import { tv, VariantProps } from 'tailwind-variants';

const switchStyle = tv({
  base: 'group inline-flex items-center rounded-full bg-gray-200 transition data-[checked]:bg-rw-main',
  variants: {
    size: {
      sm: 'h-4 w-7',
      md: 'h-6 w-11',
    },
  },
});

const toggleButtonStyle = tv({
  base: 'translate-x-1 rounded-full bg-white transition',
  variants: {
    size: {
      sm: 'size-2.5 group-data-[checked]:translate-x-3.5',
      md: 'size-4 group-data-[checked]:translate-x-6',
    },
  },
});

type ToggleProps = VariantProps<typeof switchStyle> & {
  label?: React.ReactNode;
  checked?: boolean;
  onChange: (checked: boolean) => void;
};

export const Toggle = ({
  label,
  onChange,
  checked,
  size = 'md',
}: ToggleProps) => {
  return (
    <Field>
      <Label>{label}</Label>
      <Switch
        checked={checked}
        onChange={onChange}
        className={switchStyle({ size })}
      >
        <span className={toggleButtonStyle({ size })} />
      </Switch>
    </Field>
  );
};
